import useResponsive from '@parsina/framework/clinical/src/hooks/useResponsive';
import MessagesMobile from './Messages.mobile';
import MessagesWeb from './Messages.web';

// Messages is a platform fork (DESIGN-CONCEPT-MOBILE §1.1): two render trees
// over one shared behaviour layer (`useMessages` / `Messages.shared.js`). The
// desktop surface is a two-pane conversation workspace; the phone surface is a
// list destination that drills into a full-screen thread. Nothing straddles.
const MessagesScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <MessagesMobile /> : <MessagesWeb />;
};

export default MessagesScreen;
